export const it = {
  Authentication: {
    Profile: {
      Login: 'Accesso',
      Logout: 'Disconnessione',
    },
  },
};
